'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Content, Header, Item, Root, Trigger } from '@radix-ui/react-accordion';
import classNames from 'classnames';
import styles from './accordion.module.scss';
export const AccordionRoot = Root;
export const AccordionItem = ({ className, ...props })=>/*#__PURE__*/ _jsx(Item, {
        ...props,
        className: classNames('accordion-item', styles.item, className)
    });
export const AccordionHeader = Header;
export const AccordionTrigger = ({ className, ...props })=>/*#__PURE__*/ _jsx(Trigger, {
        ...props,
        className: classNames('accordion-trigger', styles.trigger, className)
    });
export const AccordionContent = ({ className, isAnimationDisabled, ...props })=>/*#__PURE__*/ _jsx(Content, {
        ...props,
        className: classNames('accordion-content', styles.content, !isAnimationDisabled && styles['content-animation'], className)
    });

//# sourceMappingURL=accordion.js.map